export default __webpack_public_path__ + "static/media/green-bottle.d7f83a5c.png";